import map from 'lodash/map';
import { createSelector } from 'reselect';

const getServiceKeys = (state) => state.serviceKeys;
export const getServiceKeyEntities = (state) => state.entities.serviceKeys;

export const getServiceKeysSelector = createSelector(
  [getServiceKeys, getServiceKeyEntities],
  (serviceKeys, entities) => {
    const { sortedIds } = serviceKeys;
    return map(sortedIds, (id) => entities[id]);
  },
);
